import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { WhoWeServe } from '../components/WhoWeServe';
import { Testimonials } from '../components/Testimonials';
export function WhoWeServePage() {
  return <>
      <PageBanner title="Who We Serve" subtitle="Serving diverse industries and professionals across Maryland with certified fingerprinting." data-id="element-519" />
      <WhoWeServe data-id="element-520" />
      <Testimonials data-id="element-521" />
    </>;
}